import React from 'react';

import { IconProps } from './types';

export const CellDescriptionIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="26"
        viewBox="0 0 26 26"
        width="26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M18.2897 21.7513C14.7647 23.0081 11.2353 23.0081 7.7103 21.7513C6.9359 21.4762 6.3307 20.8414 6.1445 20.0417C5.0273 15.3486 5.0273 10.6514 6.1445 5.9583C6.3307 5.1628 6.9359 4.528 7.7061 4.2529C10.317 3.3219 12.9323 3.0765 15.5433 3.5251C17.4053 4.748 19.1869 6.5635 20.3887 8.7555C20.9261 12.5175 20.7484 16.2797 19.8597 20.0417C19.6692 20.8372 19.0641 21.4762 18.2897 21.7513Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M19.9909 9.2506C18.4421 9.5469 16.8933 9.4242 15.3445 8.8825C14.8367 7.4225 14.697 5.9668 14.9297 4.5068"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M8.9122 12.9196C10.5414 13.5713 12.3272 13.7194 14.041 13.3428"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M8.8867 17.0625C11.5697 17.8877 14.4303 17.8877 17.1133 17.0625"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
      </svg>
    );
  },
);
